/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'security';
const componentName = 'hsm-group-download-certificate-modal-service';
const prefix = `${moduleName}.${componentName}`;

export const hsmGroupModalName = `${prefix}.hsmGroupModalName`;

export const ENGLISH = {
    [hsmGroupModalName]: 'HSM Group',
};
